import React, { useRef } from 'react';

import Slider from 'react-slick'

import LarsRasmussen from '../../assets/images/investors/lars.png';
import JasonBarnwell from '../../assets/images/investors/jason.png';
import DavidKerr from '../../assets/images/investors/david.png';
import StephanieHamon from '../../assets/images/investors/stephanie.png';
import SteveAlbrecht from '../../assets/images/investors/steve.png';
import BenDavey from '../../assets/images/investors/ben.png';
import GaryTully from '../../assets/images/investors/gary.png';
import ChrisGrant from '../../assets/images/investors/chris.png';

import ArrowLeftIcon from '../../assets/svg/arrow-left.svg';
import ArrowRightIcon from '../../assets/svg/arrow-right.svg';

function InvestorsMobileSlider({ className }) {
  const investors =
  [
    {
      index: 0,
      name: 'Lars Rasmussen',
      description: 'Lars is a world renowned computer scientist, having co-founded Google Maps and having previously served as the director of engineering for Facebook. He holds a PhD in computer science from the University of California, Berkeley.',
      image: LarsRasmussen
    },
    {
      index: 1,
      name: 'Jason Barnwell',
      description: 'Jason is an attorney in Microsoft’s Corporate, External and Legal Affairs department. He leads the Microsoft’s Modern Legal team, with previous roles leading Legal Business, Operations and Strategy team, leading the Open Source Software practice group, and counseling the Cloud and AI platform business.',
      image: JasonBarnwell
    },
    {
      index: 2,
      name: 'David Kerr',
      description: 'David until recently was CEO of Bird & Bird for 26 years, and during that time built it up to be the leading global law firm advising companies being changed by tech. He has a passion for harnessing legaltech to improve the delivery of legal services, and advises or is involved with several companies and clients in the area.',
      image: DavidKerr
    },
    {
      index: 3,
      name: 'Stéphanie Hamon',
      description: 'Stéphanie Hamon is the Head of Legal Operations Consulting at Norton Rose Fulbright and a former Managing Director, Head of External Engagement, Legal at Barclays. She has extensive experience developing and implementing commercial and business management strategies for in-house legal departments. Stéphanie led the Barclays team that won "Legal Operations Team of the Year" at the 2019 UK Legal 500 Awards. Prior to joining Barclays, Stéphanie held leadership roles in the client services and business development functions of several global law firms in markets including the UK, Europe and Asia Pacific.',
      image: StephanieHamon
    },
    {
      index: 4,
      name: 'Steve Albrecht',
      description: 'Steve is a lawyer and tech enthusiast who has worked in private practice, in the US government and in-house between the US and UK over the past twenty five years. He is currently the General Counsel of the operations, technology and group central legal teams at Barclays based in London.',
      image: SteveAlbrecht
    },
    {
      index: 5,
      name: 'Ben Davey',
      description: 'Ben is currently CSO of Azerion Group N.V. and an early stage, growth and technology-led investor and adviser. Previously Chief Investment Officer at EFIC1, CEO and Founder of Barclays Ventures, Group Head of Strategy at Barclays, CSO and Head of FIG EMEA at Barclays Investment Bank, M&A and Advisory Banker and Chancery Barrister.',
      image: BenDavey
    },
    {
      index: 6,
      name: 'Gary Tully',
      description: 'Gary is the Head of Legal Operations at Gilead. He has a demonstrated history of working in the biotechnology and high tech industries. In late 2021, Gary’s team was awarded law.com’s ‘Best Legal Ops Team’ having navigated the development of Covid-19 treatment amidst the pandemic.',
      image: GaryTully
    },
    {
      index: 7,
      name: 'Chris Grant',
      description: 'Chris has broad experience working across the legal industry with time spent in both private practice and in-house. The majority of his career has been focused on legal operations, bringing efficiencies to traditional ways of working. Frustrated by the slow pace of change, in an industry which has been resistant to innovating, Chris has most recently been working with LawTech start ups, playing a role in building an ecosystem to support the next generation of legal services and now consults on legal operations with in-house legal teams. He built the LawTech community at Barclays Eagle Labs where he grew a collaboration space for in-house teams, law firms and tech companies. Chris has been featured in the FT Innovative Lawyers ‘Top 10 Intrepreneurs’ and appeared in the Legal 500 GC Powerlist (UK 2020 Change Agenda). Chris is also a member of the LawTech UK Panel.',
      image: ChrisGrant
    }
  ];

  const slider = useRef(null)

  return (
    <div className={`${className || ''} fit-width pb-50 pb-sm-40 d-lg-none`}>
      <div className="investor-details-container">
        <div className="button-container">
          <button className="mr-2" onClick={() => slider.current.slickPrev()}>
            <ArrowLeftIcon fill="black" />
          </button>
          <button onClick={() =>  slider.current.slickNext()}>
            <ArrowRightIcon fill="black" />
          </button>
        </div>
        <Slider
            ref={slider}
            {...{
              centerMode: true,
              centerPadding: 0,
              speed: 500,
              arrows: false,
              adaptiveHeight: true
            }}
          >
            {investors.map(investor => (
            <div key={investor.index} className="investor-details">
              <img src={investor.image} />
              <div className="details">
                <h3 className="text-white">{investor.name}</h3>
                <p className="text-white">{investor.description}</p>
              </div>
            </div>
            ))}
        </Slider>
      </div>
    </div>
  )
}

export default InvestorsMobileSlider;
